import { createRouter, createWebHistory } from "vue-router";
const routes = [
  //首页
  {
    path: "/",
    component: () => import("@/views/index/index"),
  }, //
  //颁奖
  {
    path: "/award",
    name: "award",
    component: () => import("@/views/index/award"),
    children: [
      {
        path: "m10final",
        name: "awardm10final",
        component: () => import("../views/award/m10final.vue"),
      },
      {
        path: "m50final",
        name: "awardm50final",
        component: () => import("../views/award/m10final.vue"),
      },
      {
        path: "m25final",
        name: "awardm25final",
        component: () => import("../views/award/m10final.vue"),
      },
      {
        path: "m10finalMixed",
        name: "awardm10finalMixed",
        component: () => import("../views/award/m10finalMixed.vue"),
      },
      {
        path: "m10finalMixed2025",
        name: "awardm10finalMixed2025",
        component: () => import("../views/award/m10finalMixed2025.vue"),
      },
    ],
  }, //
  //项目
  {
    path: "/project",
    component: () => import("@/views/index/project"),
  }, //
  {
    path: "/pdf",
    name: "pdf",
    component: () => import("@/views/index/pdf"),
  },
  {
    path: "/ranking",
    name: "ranking",
    component: () => import("@/views/index/ranking"),
    children: [
      // ####################################### blend团体展示
      //10米步手枪混团  第一阶段
      {
        path: "m10qualification1",
        name: "m10qualification1",
        // component: () => import('../views/showList/qualification_blend.vue'),
        component: () => import("../views/showList/qualification.vue"),
      },
      //10米混团第二阶段
      {
        path: "m10qualification2",
        name: "m10qualification2",
        component: () => import("../views/showList/qualification_blend.vue"),
      },
      //10米步手枪混团  决赛第一部分
      {
        path: "m10final4Mixed",
        name: "m10final4Mixed",
        component: () => import("../views/showList/m10final4Mixed_blend.vue"),
      },
      //10米步手枪混团 金牌赛 10米步枪金牌赛
      {
        path: "m10finalMixed",
        name: "m10finalMixed",
        component: () => import("../views/showList/m10finalMixed_blend.vue"),
      },
      // ####################################### blend团体展示

      // ####################################### qualification资格赛展示
      //50米资格赛
      {
        path: "m50Qualification",
        name: "m50Qualification",
        component: () => import("../views/showList/qualification.vue"),
      },
      //10米步枪资格赛
      {
        path: "m10Qualification",
        name: "m10Qualification",
        component: () => import("../views/showList/qualification.vue"),
      },
      //男子25米手枪  资格赛 女子25米手枪 资格赛
      {
        path: "m25qualification",
        name: "m25qualification",
        component: () => import("../views/showList/qualification.vue"),
      },
      {
        path: "m25qualification1",
        name: "m25qualification1",
        component: () => import("../views/showList/qualification.vue"),
      },
      // ####################################### qualification资格赛展示

      //50米资格赛  半决赛 左边成绩右侧弹着 环值累加展示
      {
        path: "m50final",
        name: "m50final",
        component: () => import("../views/showList/m50final.vue"),
      },
      //50米奖牌赛 金牌 有vs背景图 单组成绩
      {
        path: "m50finalMixed",
        name: "m50finalMixed",
        component: () => import("../views/showList/m50finalMixed.vue"),
      },

      // !!!!!!!!!!!!!!!!!!!!!! m10Final4 左边成绩右侧弹着 积分制  总分 本轮
      //50米奖牌赛铜牌
      {
        path: "m50Final2",
        name: "m50Final2",
        component: () => import("../views/showList/m10Final4.vue"),
      },
      //10米步枪资格赛 半决赛
      {
        path: "m10Final4",
        name: "m10Final4",
        component: () => import("../views/showList/m10Final4.vue"),
      },
      //10米步枪资格赛 铜牌
      {
        path: "m10Final2",
        name: "m10Final2",
        component: () => import("../views/showList/m10Final4.vue"),
      },

      //10米步枪资格赛 金牌 old
      {
        path: "m10final",
        name: "m10final",
        component: () => import("../views/showList/m10Final4.vue"),
      },

      // !!!!!!!!!!!!!!!!!!!!!! m25Final4 左边成绩右侧弹着 只展示 总分
      //男子25米手枪  半决赛
      {
        path: "m25Final4",
        name: "m25Final4",
        component: () => import("../views/showList/m25Final4.vue"),
      },
      //男子25米手枪  铜牌
      {
        path: "m25Final2",
        name: "m25Final2",
        component: () => import("../views/showList/m25Final4.vue"),
      },
      //男子25米手枪  铜牌
      {
        path: "m25Final",
        name: "m25Final",
        component: () => import("../views/showList/m25Final4.vue"),
      },

      //男子25米手枪  金牌 有vs背景图 五个靶子一排展示
      {
        path: "m25finalMixed",
        name: "m25finalMixed",
        component: () => import("../views/showList/m25finalMixed.vue"),
      },
    ],
  },
];
const routerHistory = createWebHistory();
const router = createRouter({
  history: routerHistory,
  routes: routes,
});

export default router;
